"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ts_money_1 = require("ts-money");
var Promo_1 = require("./Promo");
var Bundle = /** @class */ (function () {
    function Bundle(json) {
        this.id = json.id;
        this.name = json.name;
        this.price = ts_money_1.Money.fromInteger(json.price, ts_money_1.Currencies.MYR);
        this.generatedProductID = json.generatedProductID;
        this.productQuantities = json.productQuantities.map(function (j) { return new Promo_1.ProductQuantity(j); });
    }
    Object.defineProperty(Bundle.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Product';
        },
        enumerable: false,
        configurable: true
    });
    return Bundle;
}());
exports.default = Bundle;
